// generated from 36_676 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const receivedCampaignWithTagFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("received_campaign_with_tag_filter"),
  comparison_key: z.enum([
    "8", // 34_037 (92.80%)
    "7", // 2_639 (7.20%)
  ]),
  display_name: z.string(),
  // undefined: 13_546 (36.93%), defined 23_130 (63.07%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(false),
});
